
import {useSelector} from "react-redux";
import Watch from "./Watch/Watch";
import Read from "./Read/Read"
import Learn from "./Learn/Learn";
import Favourites from "./Favourites/Favourites";

export default function ViewingArea(props) {

    const {
        watchIsActive,
        readIsActive,
        learnIsActive,
        favouritesIsActive,
        watchOffCanvasIsActive,
        readOffCanvasIsActive,
        learnOffCanvasIsActive
    } = useSelector((state) => state.navBar)

    const conditionalStyles = ((watchOffCanvasIsActive || readOffCanvasIsActive || learnOffCanvasIsActive) ? "  sm:row-end-13 " : " sm:row-end-9 ")

    const viewingAreaBaseStyle = (conditionalStyles + " viewingArea row-start-4 sm:row-start-3 row-end-13  xl:row-end-13 px-4 pt-4 sm:pt-8 pb-8 col-start-1 lg:col-start-8 3xl:col-start-7 ")

    const favouritesIsNotActiveStyle = `col-end-25 xl:col-end-20 3xl:col-end-20 `
    const favouriteIsActiveStyle = " col-end-25 row-end-13 sm:row-end-25 "


    return (
        <div className={viewingAreaBaseStyle + (!favouritesIsActive ? favouritesIsNotActiveStyle : favouriteIsActiveStyle) } >
            {watchIsActive && <Watch />}
            {readIsActive && <Read />}
            {learnIsActive && <Learn />}
            {favouritesIsActive && <Favourites />}
        </div>
    );
}

